<nav #header class="fixed-top" style="background-color: white;filter: drop-shadow(1px 1px 1px #6666664d);">
    <div class="containerMenu navbar-collapse collapse">
        <!---->
        <div class="contactContainer">
            <ul class="navbar-nav contact">
                <li class="nav-item menuItem1">
                    <a href="https://www.adventurejourneys.com/tel:%20+001%20305%202805599" target="_blank">
                        <i class="fa fa-phone"></i></a>
                </li>
                <li class="nav-item menuItem1">
                    <a href="mailto:info&#64;adventurejourneys.com" target="_blank">
                        <i class="fa fa-envelope"></i></a>
                </li>
                <li class="nav-item menuItem1">
                    <a href="https://www.tripadvisor.com.ar/Attraction_Review-g294308-d13804233-Reviews-Adventure_Journeys-Quito_Pichincha_Province.html"
                        target="_blank">
                        <i class="fa fa-tripadvisor"></i></a>
                </li>
                <li class="nav-item menuItem1">
                    <a href="https://www.adventurejourneys.com/contact-us/" target="_blank">
                        <i class="fa fa-user-circle-o"></i>
                        <span>Contact Us</span></a>
                </li>
            </ul>
        </div>
        <div>
            <a href="https://www.adventurejourneys.com/" target="_blank">
                <img class="logo"
                    src="../assets/images/logos-header/aj.svg" />
            </a>
        </div>
        <div class="contactContainer">
        </div>
        <a class="menuButton" (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
    </div>
    <div #header1 class="containerHeader" [ngClass]="showMenu ? 'showMenu':''">
        <ul class="navbar-nav">
            <li class="nav-item menuItem"><a href="https://www.adventurejourneys.com/destinations/"
                    target="_blank">DESTINATIONS</a></li>
            <li class="nav-item menuItem"><a href="https://www.adventurejourneys.com/travel-style/"
                    target="_blank">TRAVEL STYLE</a></li>
            <li class="nav-item menuItem"><a href="https://www.adventurejourneys.com/extension/" target="_blank">TRIP
                    EXTENSION</a></li>
            <li class="nav-item menuItem"><a href="https://www.adventurejourneys.com/about-us/" target="_blank">WHY
                    US</a></li>
            <li class="nav-item menuItem"><a href="https://www.adventurejourneys.com/brochure/"
                    target="_blank">BROCHURE</a></li>
            <li class="nav-item menuItem"><a href="https://www.adventurejourneys.com/videos/" target="_blank">GET
                    INSPIRED</a>
            </li>
            <li class="nav-item menuItem"><a href="https://www.adventurejourneys.com/responsible-tourism/"
                    target="_blank">SUSTAINABILITY</a>
            </li>
            <li class="nav-item menuItem"><a href="https://luxuryprivatejourneys.com/" target="_blank">LUXURY
                    PRIVATE JOURNEYS</a>
            <li class="nav-item menuItem"><a href="https://waokamp.com/" target="_blank">OUR WAO KAMP</a>
        </ul>
        <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
            <app-heart-header></app-heart-header>
        </div>
    </div>
</nav>